// CASE PARTS, SET FROM CASE MENU BAR
export const CASE_PART_ONE = 'case_part_one';
export const CASE_PART_TWO = 'case_part_two';

export const caseStatus = {
  archiveStatus: {
    ACTIVE: 'Active',
    ARCHIVED: 'Archived',
  },
  workflowStatus: {
    CREATE: 'Creating case',
    WAITING: 'Waiting for analysis',
    COMPLETE: 'Analysis completed',
  },
  workFlowStatusDemo: {
    CASE_CREATED: 'Case Created',
    AWAITING_UPLOAD: 'Awaiting Upload',
   // AWAITING_PATHOLOGIST_ASSIGNMENT: 'Awaiting Pathologist Assignment',
    AWAITING_ANALYSIS: 'Awaiting Analysis',
    ANALYSIS_SUBMITTED: 'Analysis Submitted',
  },
};


export const CASE_LEVEL = 'case-level';

export const colors = {
  purpleLight: '#b8b8da',
  purpleDark: '#8080be',
};

export const userRoles = {
  admin: 'admin',
  pathologist: 'pathologist',
  val_pathologist: 'val_pathologist',
  surgeon: 'surgeon',
  technician: 'technician',
  val_technician: 'val_technician',
};

export const NOTIFICATION_STATUS = {
  info: 'INFO',
  success: 'SUCCESS',
  warning: 'WARNING',
  error: 'ERROR',
};

export const NOTIFICATION_DISPLAY_TIME_SHORT = 1500;
export const NOTIFICATION_DISPLAY_TIME_LONG = 3000;

export const TIME_DATE_FORMAT = 'MMMM Do YYYY, h:mm:ss a';

export const specimenLocationItems = [
  'Apex Right',
  'Midgland Right Midprostatic',
  'Midgland Right Lateral',
  'Base Right Midprostatic',
  'Base Right Lateral',
  'Base Left Midprostatic',
  'Base Left Lateral',
  'Midgland Left Midprostatic',
  'Midgland Left Lateral',
  'Apex Left',
  'Transitional Zone',
 // 'Transitional Zone',
];

// specimens given to a newly created case
export const defaultSpecimens = [];

// CONFIRM MODAL-TYPES
export const MODAL_CONFIRM_DISCARD_CHANGES = 'MODAL_CONFIRM_DISCARD_CHANGES';
export const MODAL_CONFIRM_DELETE_CASE = 'MODAL_CONFIRM_DELETE_CASE';
export const MODAL_CONFIRM_ACTIVATE_CASE = 'MODAL_CONFIRM_ACTIVATE_CASE';

// PATHOLOGIST ASSIGNMENT STATUS
export const ASSIGNED = 'ASSIGNED';
export const NOT_ASSIGNED = 'NOT ASSIGNED';
export const SHOULD_BE_ASSIGNED = 'SHOULD BE ASSIGNED';
export const SHOULD_BE_UNASSIGNED = 'SHOULD BE UNASSIGNED';


// FORM CONSTANTS
export const tumourTypes = {
  NO_PRIMARY_TUMOUR: 'no evidence of primary tumour',
  ADENOCARCINOMA: 'adenocarcinoma',
  OTHER: 'other',
};

export const isupGrades = {
  ISUP_GRADE_1: '1',
  ISUP_GRADE_2: '2',
  ISUP_GRADE_3: '3',
  ISUP_GRADE_4: '4',
  ISUP_GRADE_5: '5',
};


